export default __webpack_public_path__ + "static/olavsPaneKnife-bf7bd7cd314c82e8bc4729c80494c0b4.png";